import { DateTime } from 'luxon';

export const appendTimezoneOffset = (timezone, appendOffset = true) => {
  const offsetString = ` / UTC${
    DateTime.fromJSDate(new Date()).setZone(timezone.ianaName, { keepLocalTime: true }).toFormat('ZZ')
  }`;

  return appendOffset ? `${timezone.name} ${offsetString}` : timezone.name;
};
